export const ADMIN_ROLE = 'administrator';
export const RECRUITER_ROLE = 'recruiter';
export const COORDINATOR_ROLE = 'coordinator';
export const DIRECTOR_ROLE = 'director';
export const PUBLISHING_ROLE = 'publishing';
export const COMMUNITY_ROLE = 'community';
export const REPORTS_ROLE = 'reports';
